var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Store } from '@ngxs/store';
import { take, map, distinctUntilChanged, filter, delay } from 'rxjs/operators';
import { EngineState } from '../engine/state/engine.state';
import { AddHistory, RevertChapterSynchronization, CopyChapterSynchronization } from './state/history.actions';
import { HistoryModel } from './models/history.model';
import { HistoryAction } from './models/history-action.enum';
import { StoryChaptersState } from '../story/state/chapters/story.chapters.state';
import { HistoryState } from './state/history.state';
import { SetChapter } from '../story/state/chapters/story.chapters.actions';
import { ChapterService } from '../story/chapter.service';
import { SetCheckedNodes } from '../engine/state/nodes/engine.nodes.actions';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
import * as i2 from "../story/chapter.service";
var HistoryService = /** @class */ (function () {
    function HistoryService(store, chapterService) {
        this.store = store;
        this.chapterService = chapterService;
    }
    /**
     * Tap into the viewgraph events to record next state. Because viewgraph changes occur asynchronously from the engine,
     * we wait until the synchornize event is called to tap into and update history.
     */
    HistoryService.prototype.recordViewGraphHistory = function () {
        var _this = this;
        var viewGraph$ = this.store.select(EngineState.getViewGraph);
        viewGraph$
            .pipe(delay(1), filter(function (viewGraph) { return Object.values(viewGraph.nodes).length > 0; }), map(function (viewGraph) {
            var nodes = Object.values(viewGraph.nodes)
                .reduce(function (result, node) {
                result[node.id] = { id: node.id, boolState: { shown: node.boolState.shown } };
                return result;
            }, {});
            return JSON.stringify(nodes);
        }), distinctUntilChanged(), take(1))
            .subscribe(function (viewGraph) {
            var nodes = JSON.parse(viewGraph);
            _this.store.dispatch(new AddHistory(new HistoryModel(HistoryAction.SetNodeVisible, nodes)));
        });
    };
    HistoryService.prototype.resetChapter = function () {
        var chapter = this.store.selectSnapshot(StoryChaptersState.getSelectedChapter);
        if (!chapter) {
            return;
        }
        this.store.dispatch(new RevertChapterSynchronization('root', chapter.id));
        this.store.dispatch(new CopyChapterSynchronization('root', chapter.id, 'cache', chapter.id));
        var cache = this.store.selectSnapshot(HistoryState).cache;
        var synchronization = cache["root_" + chapter.id];
        chapter = __assign({}, chapter, { synchronization: __assign({}, synchronization) });
        this.store.dispatch(new SetCheckedNodes([])); // reset checked nodes.
        this.store.dispatch(new SetChapter(chapter));
        this.chapterService.addChapterToEngine(chapter, 0);
    };
    HistoryService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function HistoryService_Factory() { return new HistoryService(i0.ɵɵinject(i1.Store), i0.ɵɵinject(i2.ChapterService)); }, token: HistoryService, providedIn: "root" });
    return HistoryService;
}());
export { HistoryService };
